'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale,
    controlStateStyles = _theme2.default.controlStateStyles,
    textColors = _theme2.default.textColors,
    borderRadius = _theme2.default.borderRadius;


var styles = (0, _glamor.css)({
  width: '100%',
  padding: majorScale(1) + ' ' + minorScale(3),
  borderRadius: borderRadius[0],
  backgroundColor: controlStateStyles.default.backgroundColor,
  color: controlStateStyles.default.color,
  border: controlStateStyles.default.border,
  transition: controlStateStyles.default.transition,
  '&:focus': {
    border: controlStateStyles.focus.border,
    boxShadow: controlStateStyles.focus.boxShadow
  },
  '&::placeholder': {
    color: textColors.muted
  }
});

var Textarea = function Textarea(props) {
  return _react2.default.createElement(_Pane2.default, _extends({}, props, styles));
};

Textarea.defaultProps = {
  is: 'textarea',
  textStyle: 'body1'
};

exports.default = Textarea;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Textarea.js
// module id = 1136
// module chunks = 0